import API from '@aws-amplify/api';
import { editProductManagement } from '@/graphql/mutations';
import { getProductManagement,getProduct } from '@/graphql/queries';

export const updateProductManagement = async (APIClient, requestBody) => {
    try {
        let res = await API.graphql({
            query: editProductManagement,
            variables: { editProductManagementRequestDto: requestBody }
        });
        return res.data.editProductManagement;
    } catch (err) {
        console.log(err);
        return null;
    }
};

export const getListProductManagement = async (APIClient, requestBody) => {
    try {
        let res = await API.graphql({
            query: getProductManagement,
            variables: {
                params: requestBody
            }
        });
        return res.data.getProductManagement;
    } catch (err) {
        console.log(err);
    }
};

export const getProductById = async (APIClient, requestBody) => {
    try {
        let res = await API.graphql({
            query: getProductManagement,
            variables: {
                params: requestBody
            }
        });
        return res.data.getProductManagement;
    } catch (err) {
        console.log(err);
    }
};

export const getProductByIdAPI = async (APIClient, productId) => {
    try {
        let res = await API.graphql({
            query: getProduct,
            variables: {
                id: productId
            }
        });
        return res.data.getProduct;
    } catch (err) {
        console.log(err);
    }
};

export const getDetailByProductId = async (APIClient, requestBody) => {
    try {
        let res = await API.graphql({
            query: getProductManagement,
            variables: {
                params: requestBody
            }
        });
        return res.data.getProductManagement.productDetail;
    } catch (err) {
        console.log(err);
    }
};